import React from 'react';
import PropTypes from 'prop-types';
import { WizardStep } from '@zillow/zrs-rental-applications';
import {
  Anchor,
  Button,
  DetailedIconPaperAirplane,
  Heading,
  ICON_STATUS_TYPES,
  IconGraduationCap,
  Paragraph,
  Text,
  token,
} from '@zillow/constellation';
import { Link } from 'react-router-dom';
import useQueryVariables from '../../../hooks/useQueryVariables';
import { getApplicationsTabPath, URLS } from '../../../constants/urls';
import styled from 'styled-components';
import { BorderlessAlert } from '../DeclineApplicationPage.utils';

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const ConfirmationStep = ({ id, label, isBasedOnScreening }) => {
  const { propertyId } = useQueryVariables();

  return (
    <WizardStep id={id} label={label} data-test="confirmation-step" meta={{ hideStepNavigation: true }}>
      <DetailedIconPaperAirplane status={ICON_STATUS_TYPES.success} />
      <Heading level={4} marginTop="sm" marginBottom="sm">
        Your email was sent to the applicant
      </Heading>
      <Paragraph marginBottom="md">
        This application was archived, but you can message the applicant, if needed.
      </Paragraph>
      {isBasedOnScreening && (
        <BorderlessAlert
          icon={<IconGraduationCap fontColor="brand" />}
          marginBottom={token('spacing.md')}
          data-test="confirmation-step__alert"
          body={
            <Text>
              {`If you take any adverse action, such as declining an application, based partly or completely on information in a consumer report, the Fair Credit Reporting Act requires that you send the applicant an adverse action notice informing them of their right to see data reported about them so they can correct any inaccurate information. You'll also need to provide the reporting source's mailing address. Additional state and local restrictions may apply.`}
            </Text>
          }
          actionButton={
            <Anchor
              rel="noreferrer"
              href={URLS.FTC_CONSUMER_REPORTS}
              target="_blank"
              data-test="confirmation-step__anchor-ftc"
            >
              Learn more
            </Anchor>
          }
        />
      )}
      <StyledLink to={getApplicationsTabPath(propertyId)} data-test="confirmation-step__link">
        <Button buttonType="primary">View all applications</Button>
      </StyledLink>
    </WizardStep>
  );
};

ConfirmationStep.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isBasedOnScreening: PropTypes.bool.isRequired,
};

export default ConfirmationStep;
